import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectBranchState } from "../store/branch/selectors";
import { selectSelectedTenantId } from "../store/user/selectors";
import { getEmailsByBranches } from "../store/branch/thunks";

export const useBranchEmails = (branch_id) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const tenant_id = useSelector(selectSelectedTenantId);
  const { branchesByTenants } = useSelector(selectBranchState);

  const branchData = useMemo(
    () =>
      branchesByTenants?.[tenant_id]?.find(
        (branch) => branch.id === branch_id,
      ) ?? {},
    [branchesByTenants, tenant_id, branch_id],
  );

  useEffect(() => {
    if (!branch_id || !tenant_id || branchData.emails) return;

    const fetchEmails = async () => {
      try {
        setLoading(true);
        await dispatch(getEmailsByBranches({ tenant_id, branch_id })).unwrap();
      } finally {
        setLoading(false);
      }
    };

    fetchEmails();
  }, [branch_id, tenant_id, branchData.emails]);

  return {
    loading,
    emails: branchData.emails ?? [],
  };
};
